import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ContactsResultMessageType, ContactType, SocNetworkType } from '../../../../../types/common.type'

@Component({
  selector: 'bmcore-soc-media-block',
  templateUrl: './bmcore-soc-media-block.component.html',
  styleUrls: ['./bmcore-soc-media-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSocMediaBlockComponent implements OnInit {
  @Input() socContact: ContactType
  @Input() socContactIndex: number
  @Input() socContactsLength: number
  @Input() contactsResultMessage: ContactsResultMessageType

  @Output() updateContactsEvent = new EventEmitter<ContactType>()

  constructor() {}

  ngOnInit(): void {}

  createPlaceholder(type: SocNetworkType) {
    switch (type) {
      case 'INSTAGRAM':
        return 'https://www.instagram.com/nickname'
      case 'TWITTER':
        return 'https://twitter.com/nickname'
      case 'YOUTUBE':
        return 'https://www.youtube.com/channel/channelId'
      case 'VK':
        return 'https://vk.com/nickname'
      case 'SOUNDCLOUD':
        return 'https://soundcloud.com/nickname'
      case 'FACEBOOK':
        return 'https://www.facebook.com/nickname'
      case 'TWITCH':
        return 'https://www.twitch.tv/channel'
      case 'TIKTOK':
        return 'https://www.tiktok.com/nickname'
      case 'BEATMAKERS.TV':
        return 'https://beatmakers.tv/bm/beatmakerId'
      default:
        return 'https://example.com'
    }
  }
}
